import {
  MotifAccordion,
  MotifAccordionContent,
  MotifAccordionTrigger,
  MotifErrorMessage,
  MotifIcon,
} from "@ey-xd/motif-react";
import {
  IconoirArrowLeft,
  IconoirArrowRight,
  IconoirCodepen,
  IconoirPolarSh,
  IconoirWarningCircle,
} from "@ey-xd/motif-icon";
import Breadcrumb from "../../components/Breadcrumb";
import "./OrderExtension.scss";
import {
  GLOBAL_NOTIFICATION,
  ORDER_EXTENSION,
  ORDER_EXTENSION_HELPER_TEXT,
  SKU_EXTENSION,
  SKU_EXTENSION_HELPER_TEXT,
} from "../../Constant";
import { useEffect, useMemo, useState } from "react";
import { AppDispatch, RootState } from "../../store";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../components/Loader";
import { OrderCard } from "./Components/OrderCard/OrderCard";
import {
  callOrderExtensionSave,
  fetchEsixtingOrderData,
  fetchOrderData,
  retriveOrderSkuExtensionConfirmation,
  retrieveExtensionOrderConfirmation,
  resetOrderExtensionSate,
} from "../../store/slices/OrderExtensionSlice";
import { OrderCardExtension } from "./Components/OrderCardExtension/OrderCardExtension";
import { Accordian } from "./Components/Accordian/Accordian";
import InputBox from "../../components/Form/InputBox/InputBox";
import {
  getTotalOrderAmount,
  getTotalOrderAmountVariable,
} from "./OrderExtensionHelper";
import { variableTotalInfo } from "../../utils/skuTable";
import Button from "../../components/Button/Button";
import {
  OrderExtensionExistingProps,
  OrderExtensionProps,
  SkuDetailsExistingOrderType,
} from "./type";
import NotificationGrid from "../../components/Notification/NotificationGrid";
import { OrderPlaced } from "./Components/OrderPlaced/OrderPlaced";
import checkoutEmptyImg from "../../assets/images/checkout-empty-state.svg";
import { useNavigate, useParams } from "react-router";
import CancelOrderModal from "./Components/DeleteOrderModal/CancelOrderModal";
import InfoTooltip from "../../components/InfoTooltip";
import { isEmpty } from "../../utils/Validator";

const OrderExtension: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { orderID = "", skuID = "" } = useParams();
  const currentOrderId = Number(orderID);
  const currentOrderSkuId = Number(skuID);
  const isSkuExtension = currentOrderSkuId > 0;
  const orderExtensionLoading = useSelector(
    (state: RootState) => state.OrderExtensionSlice.isLoading,
  );
  const orderExtensionData = useSelector(
    (state: RootState) => state.OrderExtensionSlice.data,
  );
  const [isLoadingOrderNow, setIsLoadingOrderNow] = useState(false);
  const [isOrderExtensionSuccess, setIsOrderExtensionSuccess] = useState(false);
  const [orderExtensionDataState, setOrderExtensionDataState] =
    useState<OrderExtensionProps | null>(null);
  const [isDataLoadingError, setIsDataLoadingError] = useState(false);
  const [orderExistingData, setOrderExistingData] =
    useState<OrderExtensionExistingProps | null>(null);
  const [engagementData, setEngagementData] = useState<
    {
      EngagementId: string;
      EngagementName: string;
    }[]
  >([]);
  const navigate = useNavigate();
  const [isOrderSaveError, setIsOrderSaveError] = useState(false);
  const [isOpportunityCodeError, setIsOpportunityCodeError] = useState(false);
  const [isShowCancelModal, setIsShowCancelModal] = useState(false);
  const orderExtensionError = useSelector(
    (state: RootState) => state.OrderExtensionSlice.error,
  );
  const showEngagementException = engagementData.length > 1 ? true : false;
  const [existingOrderLoading, setExistingOrderLoading] = useState(false);
  const [opportunityCode, setOpportunityCode] = useState("");
  const [skuConfirmationResponse, setSkuConfirmationResponse] =
    useState<any>(null);
  const [orderConfirmationResponse, setOrderConfirmationResponse] =
    useState<any>(null);
  const [engagementNameExceptionError, setEngagementNameExceptionError] =
    useState<string[]>([]);
  const [showVariableCost, setShowVariableCost] = useState(false);
  useEffect(() => {
    if (orderExtensionError !== null) {
      setIsDataLoadingError(true);
    } else {
      setIsDataLoadingError(false);
    }
  }, [orderExtensionError]);

  useEffect(() => {
    if (currentOrderId > 0) {
      dispatch(resetOrderExtensionSate());
      dispatch(
        fetchOrderData({
          Action: "retriveOrderSkuExtensionList",
          OrderId: currentOrderId,
          OrderSkuId: isSkuExtension ? currentOrderSkuId : undefined,
        }),
      );
      const fetchExistingOrderData = async () => {
        try {
          setExistingOrderLoading(true);
          const response = await dispatch(
            fetchEsixtingOrderData({
              Action: "orderDetails",
              OrderId: currentOrderId,
            }),
          ).unwrap();
          setExistingOrderLoading(false);
          if (response.Status === "success" && response.Code === 200) {
            setOrderExistingData(response.Data);
          } else {
            setOrderExistingData(null);
            setIsDataLoadingError(true);
          }
          // Handle the response if needed
        } catch (error) {
          setIsDataLoadingError(true);
          console.error("Failed to fetch existing order data:", error);
        }
      };

      fetchExistingOrderData();
    } else {
      setIsDataLoadingError(true);
    }
    () => {
      dispatch(resetOrderExtensionSate());
    };
  }, [dispatch, currentOrderId]);

  useEffect(() => {
    // Cleanup function runs on unmount
    return () => {
      dispatch(resetOrderExtensionSate());
    };
  }, [dispatch]);

  useEffect(() => {
    if (
      orderExtensionData &&
      orderExtensionData !== null &&
      orderExtensionData !== undefined
    ) {
      const orderExtensionDataFormatted =
        orderExtensionData.Details && Array.isArray(orderExtensionData.Details)
          ? {
              ...orderExtensionData,
              Details: orderExtensionData.Details.map(
                (detail: {
                  ProductName: string;
                  SkuDetails: SkuDetailsExistingOrderType[];
                }) => ({
                  ...detail,
                  SkuDetails: detail.SkuDetails.map(
                    (sku: SkuDetailsExistingOrderType) => {
                      return {
                        ...sku,
                        OrderSkuIntervals: 0,
                        SkuRelation:
                          sku?.SkuRelation?.map((relation: any) => ({
                            ...relation,
                            OrderSkuIntervals: 0,
                          })) || [],
                      };
                    },
                  ),
                }),
              ),
            }
          : orderExtensionData;

      setOrderExtensionDataState(orderExtensionDataFormatted as any);
    }
  }, [orderExtensionData]);

  useEffect(() => {
    if (
      engagementData &&
      engagementData.length === 0 &&
      orderExtensionDataState !== null
    ) {
      let engData = orderExtensionDataState?.EngagementDetails || [];
      if (engData && engData.length > 1) {
        engData = [...engData].sort((a, b) =>
          b.EngagementId.localeCompare(a.EngagementId),
        );
      }
      setEngagementData(engData);
    }
  }, [engagementData, orderExtensionDataState]);

  useEffect(() => {
    if (isEmpty(opportunityCode) && orderExtensionDataState !== null) {
      const opportunityCodeApi =
        orderExtensionDataState &&
        orderExtensionDataState.Details &&
        orderExtensionDataState.Details.length > 0
          ? orderExtensionDataState.Details[0].SkuDetails[0].OpportunityId || ""
          : "";
      setOpportunityCode(opportunityCodeApi);
    }
  }, [orderExtensionDataState]);

  const memorisedTotal = useMemo(
    () => getTotalOrderAmount(orderExtensionDataState?.Details || []),
    [orderExtensionDataState],
  );
  const memorisedTotalVariable = useMemo(
    () => getTotalOrderAmountVariable(orderExtensionDataState?.Details || []),
    [orderExtensionDataState],
  );

  useEffect(() => {
    const cleanNumber = memorisedTotalVariable.replace(/[$,]/g, "");
    if (!isNaN(Number(cleanNumber))) {
      setShowVariableCost(Number(cleanNumber) > 0);
    }
  }, [memorisedTotalVariable]);

  const isErrorDuration = useMemo(() => {
    let isError = false;
    if (!orderExtensionDataState || !orderExtensionDataState.Details) {
      return false;
    }
    for (const detail of orderExtensionDataState.Details) {
      for (const sku of detail.SkuDetails) {
        if (sku.DurationError) {
          isError = true;
        }
        if (sku.SkuRelation && sku.SkuRelation.length > 0) {
          for (const relation of sku.SkuRelation) {
            if (relation.DurationError) {
              isError = true;
            }
          }
        }
      }
    }
    return isError;
  }, [orderExtensionDataState]);
  const breadcrumbItems = [
    {
      label: "External Submission",
      value: "Home",
      elementKey: "submission",
      text: "Home",
      url: `/`,
      icon: <MotifIcon src={IconoirArrowLeft} />,
    },
    {
      label: "External Submission",
      value: "Checkout",
      elementKey: "submission",
      text: "Cart Preview",
      url: `/order-extension`,
      disabled: true,
      icon: <MotifIcon src={IconoirArrowLeft} />,
    },
  ];
  if ((orderExtensionLoading || existingOrderLoading) && !isDataLoadingError) {
    return <Loader />;
  }

  let activeSkus: {
    OrderSkuId: number;
    AdditionalIntervals: number;
    EngagementId: string | null;
  }[] = [];
  if (orderExtensionDataState && orderExtensionDataState.Details) {
    orderExtensionDataState.Details.forEach((detail) => {
      detail.SkuDetails.forEach((sku) => {
        if (sku.OrderSkuIntervals && sku.OrderSkuIntervals > 0) {
          activeSkus.push({
            OrderSkuId: sku.OrderSkuId,
            AdditionalIntervals: sku.OrderSkuIntervals,
            EngagementId: sku.EngagementId,
          });
        }
        if (sku.SkuRelation && sku.SkuRelation.length > 0) {
          sku.SkuRelation.forEach((relation) => {
            if (relation.OrderSkuIntervals && relation.OrderSkuIntervals > 0) {
              activeSkus.push({
                OrderSkuId: relation.OrderSkuId,
                AdditionalIntervals: relation.OrderSkuIntervals,
                EngagementId: relation.EngagementId,
              });
            }
          });
        }
      });
    });
  }

  const handleOrderNow = async () => {
    if (activeSkus.length === 0) {
      return;
    }
    try {
      const formData = {
        Action: "extendOrderSku",
        OrderSkuExtensions: activeSkus.map((sku) => ({
          ...sku,
          OrderSkuId: sku.OrderSkuId.toString(),
        })),
        opportunityCode: opportunityCode,
        isSkuExtension,
      };
      setEngagementNameExceptionError([]);
      setIsLoadingOrderNow(true);
      setIsOrderSaveError(false);
      const response = await dispatch(callOrderExtensionSave(formData));
      setIsLoadingOrderNow(false);
      if (response.payload.Status === "success") {
        if (isSkuExtension) {
          dispatch(
            retriveOrderSkuExtensionConfirmation({
              Action: "retriveOrderSkuExtensionConfirmation",
              OrderSkuId: currentOrderSkuId,
            }),
          )
            .then((response: any) => {
              if (
                response.payload.Status === "success" &&
                response.payload.Code === 200
              ) {
                setSkuConfirmationResponse(response.payload.Data);
                setIsOrderExtensionSuccess(true);
              } else {
                setIsOrderSaveError(true);
                setSkuConfirmationResponse(null);
              }
            })
            .catch((error: any) => {
              setIsOrderSaveError(true);
              setSkuConfirmationResponse(null);
              console.error("Failed to fetch existing order data:", error);
            });
        } else {
          dispatch(
            retrieveExtensionOrderConfirmation({
              Action: "orderExtension",
              OrderId: currentOrderId,
            }),
          )
            .then((response: any) => {
              if (
                response.payload.Status === "success" &&
                response.payload.Code === 200
              ) {
                setOrderConfirmationResponse(response.payload.Data);
                setIsOrderExtensionSuccess(true);
              } else {
                setIsOrderSaveError(true);
                setOrderConfirmationResponse(null);
              }
            })
            .catch((error: any) => {
              setOrderConfirmationResponse(null);
              setIsOrderSaveError(true);
              console.error("Failed to fetch existing order data:", error);
            });
        }
      } else {
        if (response?.payload?.payload.length > 0) {
          const engagementIds = response.payload.payload
            .filter((item: any) =>
              item?.EngagementErrorMessage?.toLowerCase().includes("expired"),
            )
            .map((item: any) => item.EngagementId)
            .filter(Boolean);
          if (engagementIds.length > 0) {
            setEngagementNameExceptionError(engagementIds);
          } else {
            setIsOrderSaveError(true);
          }
        } else {
          const responseMessage = response.payload.message.toLowerCase();
          let opportunityPos = responseMessage.search("opportunity code");
          if (opportunityPos !== -1) {
            setIsOpportunityCodeError(true);
          } else {
            setIsOrderSaveError(true);
            console.error("Order extension failed:");
          }
        }
      }
    } catch (error) {
      setIsOrderSaveError(true);
      console.error("Failed to place order:", error);
    }
  };

  const isorderExtensionDataEmpty =
    orderExtensionData === undefined || orderExtensionData === null;
  if (
    orderExtensionData === null ||
    isorderExtensionDataEmpty ||
    orderExistingData === null ||
    isDataLoadingError
  ) {
    return (
      <div className="order-extension-empty-state">
        <img src={checkoutEmptyImg} alt="Empty Checkout Page" />
        <>
          {isDataLoadingError ? (
            <p>
              Something went wrong while loading the data. Please try again
              later.
            </p>
          ) : (
            <>
              <p>You don’t have anything in your order Extension yet.</p>
              <p className="suggestion-text">
                Add products to create your order bundle first, Once you do,
                they’ll appear here.
              </p>
            </>
          )}
        </>

        <Button
          variant="primary"
          className="order-extension-empty-state-btn"
          onClickHandler={() => navigate("/order-pipeline/orders")}
          label="Go to Order Pipeline page"
        />
      </div>
    );
  }

  if (isOrderExtensionSuccess) {
    return (
      <OrderPlaced
        orderData={
          isSkuExtension ? skuConfirmationResponse : orderConfirmationResponse
        }
        isSKUExtensionConfirmation={isSkuExtension}
      />
    );
  }

  return (
    <>
      <div className="order-extension-detail-wrapper">
        <section
          className={`order-extension-content-header order-extension-header-banner-lg`}
        >
          <div className="order-extension-cost-setup-breadcrumb">
            <Breadcrumb
              items={breadcrumbItems}
              ariaLabel="Breadcrumb navigation"
            />
          </div>
          <div className="order-name-grid">
            <h1 className="order-extension-title">
              {isSkuExtension ? SKU_EXTENSION : ORDER_EXTENSION}
            </h1>
          </div>
          <div className="order-extension-description">
            {isSkuExtension
              ? SKU_EXTENSION_HELPER_TEXT
              : ORDER_EXTENSION_HELPER_TEXT}
          </div>
        </section>
        <div className="main-container">
          <div className="left-grid">
            <div className="order-overview-table-container">
              <section className="existing-order-container">
                <div className="existing-order-title-grid">Existing order</div>
                {isOrderSaveError && (
                  <NotificationGrid
                    message={GLOBAL_NOTIFICATION.UNEXPECTED_ERROR}
                  />
                )}
                <div>
                  {
                    <OrderCard
                      orderExistingData={orderExistingData}
                      engagementData={engagementData}
                    />
                  }
                </div>
              </section>
            </div>
            <div className="order-extension-table-container">
              <section className="existing-order-container">
                <div className="existing-order-title-grid">
                  {isSkuExtension ? SKU_EXTENSION : ORDER_EXTENSION}
                </div>
                <div>
                  <div>
                    {Array.isArray(orderExtensionDataState?.Details) &&
                      orderExtensionDataState?.Details?.map(
                        (orderDataRow: {
                          ProductName: string;
                          SkuDetails: SkuDetailsExistingOrderType[];
                        }) => {
                          return (
                            <OrderCardExtension
                              key={orderDataRow.ProductName}
                              productName={orderDataRow.ProductName}
                              skuDetails={orderDataRow.SkuDetails.map(
                                (sku: SkuDetailsExistingOrderType) => ({
                                  ...sku,
                                  Indexation: sku.Indexation ?? 0,
                                  CostMetricNSR: sku.CostMetricNSR ?? 0,
                                  OrderQuantity: 0,
                                }),
                              )}
                              setOrderExtensionDataState={
                                setOrderExtensionDataState
                              }
                              orderExtensionDataState={orderExtensionDataState}
                            />
                          );
                        },
                      )}
                  </div>
                </div>
              </section>
            </div>
          </div>

          <div className="order-extension-cost-container">
            <div className="order-extension-content-body-view-details">
              <div className="cost-estimate-grid">
                <div className="cost-estimate-title">Total cost</div>
                <div>
                  <div className="cost-estimate-value order-total">
                    {memorisedTotal}{" "}
                  </div>
                  {showVariableCost && (
                    <div className="cost-estimate-value-support">
                      <div className="variable-cost-info-grid">
                        <div>{memorisedTotalVariable} Variable cost</div>
                        <InfoTooltip
                          description={variableTotalInfo()}
                          info={true}
                          id="variable-total-cost-info"
                          size="14"
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="cost-breakdown-grid">
                <div className="cost-breakdown-container">
                  <div>
                    <MotifAccordion
                      variant="functional"
                      useChevronIcon
                      className="cost-breakdown-accordian"
                    >
                      <MotifAccordionTrigger className="cost-breakdown-title-grid">
                        Cost breakdown
                      </MotifAccordionTrigger>
                      <MotifAccordionContent className="cost-breakdown-accordian-content">
                        {!isorderExtensionDataEmpty &&
                          orderExtensionDataState?.Details.map(
                            (orderDataRow, index) => (
                              <Accordian
                                key={index}
                                skuDetails={orderDataRow.SkuDetails}
                                productName={orderDataRow.ProductName}
                              />
                            ),
                          )}
                      </MotifAccordionContent>
                    </MotifAccordion>
                  </div>
                </div>
                <div className="cost-breakdown-table opportunity">
                  <div className="discription-row InputElement">
                    <label htmlFor="opportunityCode">Opportunity Code</label>
                    <InputBox
                      aria-label="Opportunity Code"
                      name="opportunityCode"
                      label="Opportunity Code"
                      placeholder="Enter opportunity Code"
                      className="opportunity-name-input"
                      type="text"
                      value={opportunityCode}
                      readonly={true}
                      prefix={
                        <MotifIcon
                          src={IconoirPolarSh}
                          className={`opportunityCode-icon}`}
                        />
                      }
                      onChange={(e) => {
                        setOpportunityCode(e.target.value);
                        setIsOpportunityCodeError(false);
                      }}
                      hideClearButton={true}
                      error={
                        isOpportunityCodeError
                          ? {
                              isError: true,
                              message: "Opportunity code is not valid.",
                            }
                          : undefined
                      }
                    />
                    {isOpportunityCodeError ? (
                      <MotifErrorMessage
                        aria-live="assertive"
                        role="alert"
                        id="aria-error-primaryList"
                      >
                        Opportunity code is not valid.
                      </MotifErrorMessage>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="cost-breakdown-table engagementCode">
                  <div className="discription-row InputElement">
                    <label htmlFor="engagementCode">Engagement Code</label>
                    <div className="engagement-grid">
                      <InputBox
                        aria-label="Engagement Code"
                        name="engagementCode"
                        label="Engagement Code"
                        placeholder="Enter a valid engagement code"
                        className="engagementCode-name-input"
                        type="text"
                        value={engagementData[0]?.EngagementId || ""}
                        readonly={true}
                        onChange={() => {}}
                        hideClearButton={true}
                        prefix={
                          <MotifIcon
                            src={IconoirCodepen}
                            className={`engagementCode-icon ${
                              engagementNameExceptionError.includes(
                                engagementData[0]?.EngagementId,
                              )
                                ? "error"
                                : ""
                            }`}
                          />
                        }
                        suffix={
                          engagementNameExceptionError.includes(
                            engagementData[0]?.EngagementId,
                          ) ? (
                            <MotifIcon
                              src={IconoirWarningCircle}
                              className="engagementCode-icon error"
                            />
                          ) : (
                            ""
                          )
                        }
                      />
                      <div className={`engagement-name`}>
                        {engagementData[0]?.EngagementName || ""}
                      </div>
                    </div>
                    {engagementNameExceptionError.includes(
                      engagementData[0]?.EngagementId,
                    ) && (
                      <MotifErrorMessage
                        aria-live="assertive"
                        role="alert"
                        id="aria-error-primaryList"
                        className="error-message-truncate"
                      >
                        <div className="sku-error-title">
                          {`${engagementData[0]?.EngagementId} is expired and cannot be used for this order extension. Please contact your Engagement partner.`}
                        </div>
                      </MotifErrorMessage>
                    )}
                  </div>
                </div>
                <div
                  className={`cost-breakdown-table engagementCode ${
                    !showEngagementException ? "hide" : ""
                  }`}
                >
                  <div className="discription-row InputElement">
                    <label htmlFor="engagementCode">
                      Provide an E-Code for this exception (required)
                    </label>
                    <div className="engagement-grid">
                      <InputBox
                        aria-label="Engagement Code Exception"
                        name="engagementCodeException"
                        label="Engagement Code Exception"
                        placeholder="Enter a valid E-Code"
                        className="engagementCode-name-input"
                        type="text"
                        value={engagementData[1]?.EngagementId || ""}
                        onChange={(e) => {
                          setOpportunityCode(e.target.value);
                        }}
                        readonly={true}
                        hideClearButton={true}
                        prefix={
                          <MotifIcon
                            src={IconoirCodepen}
                            className={`engagementCode-icon ${
                              engagementNameExceptionError.includes(
                                engagementData[1]?.EngagementId,
                              )
                                ? "error"
                                : ""
                            }`}
                          />
                        }
                        suffix={
                          engagementNameExceptionError.includes(
                            engagementData[1]?.EngagementId,
                          ) ? (
                            <MotifIcon
                              src={IconoirWarningCircle}
                              className="engagementCode-icon error"
                            />
                          ) : (
                            ""
                          )
                        }
                      />
                      <div
                        className={`engagement-name 
                                                    !engagementNameExceptionError
                                                    ? ""
                                                    : "hide"
                                                    }`}
                      >
                        {engagementData[1]?.EngagementName || ""}
                      </div>
                    </div>
                    {engagementNameExceptionError.includes(
                      engagementData[1]?.EngagementId,
                    ) && (
                      <MotifErrorMessage
                        aria-live="assertive"
                        role="alert"
                        id="aria-error-primaryList"
                        className="error-message-truncate"
                      >
                        <div className="sku-error-title">
                          {`${engagementData[1]?.EngagementId} is expired and cannot be used for this order extension. Please contact your Engagement partner.`}
                        </div>
                      </MotifErrorMessage>
                    )}
                  </div>
                </div>
              </div>
              <div className="checkout-content-body-view-details-btns second">
                <div className="checkout-view-details-btn-wrapper">
                  <Button
                    className="checkout-view-details-cancel-btn"
                    variant="secondary"
                    onClickHandler={() => {
                      setIsShowCancelModal(true);
                    }}
                    label="Cancel"
                  />
                </div>
                <div className="checkout-view-details-btn-wrapper">
                  <Button
                    className="checkout-view-details-save-btn"
                    variant="primary"
                    onClickHandler={handleOrderNow}
                    label={isSkuExtension ? "Extend SKU" : "Extend Order"}
                    disabled={activeSkus.length === 0 || isErrorDuration}
                    loading={isLoadingOrderNow}
                    children={
                      <MotifIcon
                        iconFunction={IconoirArrowRight}
                        size="24"
                        title="Add to Order Bundle"
                      />
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <CancelOrderModal
        isVisible={isShowCancelModal}
        popupCloseHandler={() => setIsShowCancelModal(false)}
      />
    </>
  );
};
export default OrderExtension;
